module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_5010.ae1ffcd8.png";